<template>
    <asset-register-documents-setup 
        :dialog="dialog" 
        :data="documentFormData" 
        @update:dialog="dialog = $event" 
    />  
    <v-window-item value="documents">
        <v-card-text>
            <v-row>
                <v-col cols="12">
                    <div class="d-flex justify-space-between align-center mb-4">
                        <h2 class="text-h6">Asset Documents</h2>
                        <v-btn
                            @click="openAssetDocument"
                            color="primary"
                            variant="tonal"
                            prepend-icon="mdi mdi-plus"
                            rounded="xl"
                        >
                            Add Asset Document
                        </v-btn>
                    </div>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12" class="pa-1">
                    <v-data-table
                        :headers="documentsHeaders"
                        :items="documentsData"
                        :loading="loading"
                        :hover="true"
                        density="compact"
                        elevation="0"
                        class="border-sm rounded-md"
                    >

                        <template v-slot:item.file_path="{ item }">
                            <div class="d-flex align-center justify-center">
                                <v-btn
                                v-if="item.file_path"
                                variant="text"
                                icon="mdi-download"
                                color="primary"
                                :href="getFullFileUrl(item.file_path)"
                                target="_blank"
                                download
                                ></v-btn>
                                <span v-else class="text-grey">No File</span>
                            </div>
                        </template>

                        <template v-slot:item.status="{ item }">
                            <v-chip
                            v-if="item.status == 1"
                            color="success"
                            size="small"
                            class="text-capitalize">
                                Active
                            </v-chip>

                            <v-chip
                            v-else
                            color="red"
                            size="small"
                            class="text-capitalize">
                                Inactive
                            </v-chip>
                        </template>

                        <template v-slot:item.actions="{ item }">
                            <v-btn 
                                icon 
                                size="small" 
                                variant="text" 
                                color="orange"
                                @click="editComponent(item)"
                            >
                                <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-card-text>
    </v-window-item>
</template>

<script>
import assetRegisterDocumentsSetup from '@/components/module/asset/assetRegistration/assetRegisterDocuments/assetRegisterDocumentsSetup.vue';

export default {
    props: {
        documentsData: {
            type: Array,
            default: () => []
        },
        loading: {
            type: Boolean,
        }
    },
    components: {
        assetRegisterDocumentsSetup,
    },
    data: () => ({
        dialog: false,
        defaultImage: '/src/assets/no_preview.jpeg',
        previewImage: null,
        loading: false,
        documentFormData: {
            id: null,
            asset_register_id: null,
            title: "",
            status: 1,

        },
        documentsHeaders: [
            { title: "#SL", align: "center", key: "id", width: "40px", sortable: false },
            { title: "Tite", key: "title", align: "left", sortable: false },
            { title: "File", key: "file_path", align: "center", sortable: false },
            { title: "Status", key: "status", align: "center", sortable: false },
            { title: "Action", key: "actions", align: "center", sortable: false },
        ],
    }),
    computed: {},
    watch: {
        documentsData(newval) {
            console.log(newval)
        }
    },
    created() {},
    methods: {
        openAssetDocument() {
            this.documentFormData = {
                id: null,
                asset_register_id: null,
                title: "",
                status: "1",
            };
            this.dialog = true;
        },
        editComponent(item) {
            this.documentFormData = { ...item };
            this.dialog = true;
        },
        getFullFileUrl(filePath) {
            if (!filePath) return "";
            return "http://127.0.0.1:8000/" + filePath;
        }
    },
    setup(props, {emit}){
        
    },
    mounted() {
        
    },
}
</script>